import { typedQuery } from "../../../typed-query";
import type { FinAcademyEventPage, FinAcademyEventPageListItem } from "./types";
import {
  eventFragment,
  heroFragment,
  contentBlocksFragment,
} from "../../fragments/events";

/**
 * @returns the full event page data for a given fin-academy slug
 *
 * Extends the shared eventFragment with:
 * - hero.ctas (call-to-action buttons)
 * - highlightColor (from the palette)
 *
 * The second `hero` projection overrides the one from eventFragment,
 * which is standard GROQ override behavior.
 */
export const finAcademyEventPageQuery = typedQuery<FinAcademyEventPage>(`
*[_type == "finAiEventPage" && path.current == $slug && eventReference->series == "fin-academy"][0]{
  ${eventFragment},
  hero {
    ${heroFragment},
    ctas[]{
      _key,
      label,
      href
    }
  },
  "highlightColor": palette.highlightColor.hex,
  ${contentBlocksFragment}
}`);

/**
 * @returns the metadata for a fin-academy event page
 */
export const finAcademyEventPageMetadataQuery = typedQuery<
  Pick<FinAcademyEventPage, "slug" | "seo" | "eventReference">
>(`
*[_type == "finAiEventPage" && path.current == $slug && eventReference->series == "fin-academy"][0]{
  "slug": path.current,
  seo,
  eventReference->{
    title
  }
}`);

/**
 * @returns all fin-academy event page list items
 */
export const finAcademyAllEventPagesQuery = typedQuery<
  FinAcademyEventPageListItem[]
>(`
*[_type == "finAiEventPage" && eventReference->series == "fin-academy"]{
  _id,
  "slug": path.current,
  eventReference->{
    _id,
    title,
    lifecycleStatus,
    series,
    attendanceType,
    timings
  }
}`);
